export const environment = {
  production: true,
  apiUrl: `${window.location.origin}/API/`,
  pdfUrl: `${window.location.origin}/RPT/`
};
